// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ih","controlPlay":"ii","controlElement":"ij","lowerControlWrapper":"ik","lowerControlIconWrapper":"il","lowerControlIcon":"im","show":"in"};